export default "__VITE_ASSET__CNdtWKch__"